import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As a tech leader at a regulatory authority, you're at the intersection of
                compliance and digital innovation. How are you leveraging emerging technologies like
                AI and advanced data analytics to strengthen regulatory oversight and improve
                operational efficiency at QFCRA?
              </strong>
            </h5>

            <h5 className="text-white">
              At QFCRA, emerging technologies are not just tools — they’re strategic enablers for
              modern regulation. One of our key initiatives has been embedding AI into internal
              review processes. For example, we’re exploring the use of machine learning models to
              assist in analyzing patterns within regulatory submissions, flag anomalies in
              financial data, and support predictive supervision.
              <br />
              <br />
              On the data side, we’re developing dashboards that visualize reporting trends from
              regulated entities using analytics tools, improving supervisors interpret and act on
              data. This enhances transparency, streamlines validation procedures, and strengthens
              evidence-based regulatory decisions.
              <br />
              <br />
              Operationally, we’ve automated workflows across Finance, HR and OD using D365 and
              SharePoint online, saving time and reducing human error. These AI and data-driven
              improvements ensure our oversight mechanisms stay both agile and compliant with
              international standards.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- You're responsible for maintaining core business systems while enabling
                transformation. How do you ensure system stability and compliance while driving
                digital innovation across ERP and core regulatory applications? What’s been your
                approach to integrating agility into legacy systems?
              </strong>
            </h5>
            <h5 className="text-white">
              System stability is foundational to regulatory credibility, but so is the ability to
              innovate. I’ve maintained this balance by embracing a phased approach. For instance,
              with our Microsoft Dynamics 365 ERP system and SharePoint platforms, we’ve implemented
              enhancements and integrations incrementally, ensuring stability during each change.
              <br />
              <br />
              Agility comes from structuring these systems to support plug-and-play upgrades—such as
              integrating Cornerstone and OrgPlus with D365 or building new modules on SharePoint
              without disrupting existing features.
              <br />
              <br />
              We’ve also established robust QA and change control protocols, including user
              acceptance testing, staged rollouts, and strong documentation. Compliance is built in
              at every layer—whether through role-based access control, audit trails, or periodic
              reviews with internal stakeholders.
              <br />
              <br />
              Our system modernization projects, like moving regulatory applications to Azure and
              integrating AI for translations, are driven with a dual lens: protecting system
              integrity while enabling smarter, faster operations.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-IT is no longer a silo—especially in regulatory institutions. What strategies have
                you found most effective in promoting collaboration between IT, compliance, and
                business units to align on digital priorities and risk mitigation?
              </strong>
            </h5>
            <h5 className="text-white">
              In a regulatory authority, collaboration isn’t optional — it’s critical. I facilitate
              this through structured working groups, regular stakeholder dialogues, co-created
              requirements documentation and continuous feedback loops.
              <br />
              <br />
              Each major system (ERP, FIRMS, Intranet, etc.) has a stakeholder group that
              contributes to roadmap discussions, defines business requirements, and validates
              outcomes. This has proven effective in gaining buy-in and aligning IT deliverables
              with regulatory priorities.
              <br />
              <br />I also work closely with Compliance and Legal from the early stages of any new
              system implementation to ensure that data handling, reporting standards, and user
              access all meet governance protocols.
              <br />
              <br />
              What has made the biggest difference, though, is the mindset shift—positioning IT not
              just as a support function, but as a strategic partner in the RA’s mission.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You've managed complex enterprise solutions within strict frameworks. In a highly
                regulated environment like QFCRA, how do you evaluate and implement new technologies
                without compromising compliance or security?
              </strong>
            </h5>
            <h5 className="text-white">
              The adoption of new technologies in a regulatory authority must be deliberate and
              risk-aware. At QFCRA, I follow a disciplined technology evaluation process that
              includes:
              <br />
              <ul>
                <li>
                  Risk assessments covering data security, regulatory impact, and vendor compliance
                  with local laws
                </li>
                <li>Pilot programs to test innovations in sandbox environments</li>
                <li>
                  Stakeholder involvement, particularly from Compliance, Legal, and Information
                  Security, before any full deployment
                </li>
                <li>
                  Documentation and audit trails for every step of the evaluation, approval, and
                  implementation process
                </li>
                <li>
                  For instance, when implementing the AI-Assisted Translation System and modernizing
                  FIRMS/ESS to cloud-based architecture, we built in data protection layers, ensured
                  secure API integrations, and kept senior stakeholders informed throughout.
                </li>
              </ul>
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With your diverse background in systems, QA, and AI, you bring a future-focused
                lens to your work. Looking ahead, what role do you see AI and intelligent automation
                playing in transforming financial regulation and internal operations within
                regulatory bodies?
              </strong>
            </h5>
            <h5 className="text-white">
              AI is becoming indispensable for regulatory bodies aiming to stay ahead of complex,
              fast-moving markets. I see three core areas of transformation: I envision AI
              supporting predictive supervision, risk-based profiling of regulated entities, and
              dynamic dashboards for real-time insights—transforming how regulatory bodies like
              QFCRA engage with data and make decisions.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
